import { useContext, useEffect, useState } from 'react';

import { AuthContext } from '../contexts/AuthContext.js';

export function useIsAuthenticated() {
  const auth = useContext(AuthContext);
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isLoggedIn());
  useEffect(
    () => auth.subscribe(() => setIsAuthenticated(auth.isLoggedIn())),
    [auth],
  );

  return isAuthenticated;
}
